import { ACTIVE, INACTIVE } from 'utils/appConstant';

// Only these two statuses are accepted for Partner Users.
// Any other value from the API is treated as invalid (mess) data.
export const VALID_STATUSES = [ACTIVE, INACTIVE];

// Options for Ant Design <Select> / status controls
export const STATUS_OPTIONS = VALID_STATUSES.map((s) => ({ label: s, value: s }));

// true only for exactly 'ACTIVE' or 'INACTIVE' (case-sensitive)
export const isValidStatus = (status) => VALID_STATUSES.includes(status);

// Throws if the status is not allowed. Used by sagas before calling the API.
// Returns the status so it can be used inline: status: assertValidStatus(value)
export const assertValidStatus = (status, context = 'Partner user') => {
  if (!isValidStatus(status)) {
    throw new Error(
      `${context}: invalid status "${status}". Allowed values: ${VALID_STATUSES.join(', ')}`
    );
  }
  return status;
};